app.controller('forgetPasswordCtrl', ['$scope', '$http', '$window', '$q',
    function ($scope, $http, $window, $q) {

    $scope.user_reset = {};

    $scope.UserNID = '';

    $scope.back = function () {
        $window.location.href = "#/dashboard";
    }

    $scope.submit = function () {

        //ecnrypt email
        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

        var plaintext = $scope.user_reset.Email;

        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        //captcha
        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }

        //send request resendOTP
        var data = {
            Email: encrypted.toString(),
            challenge: challenge
        }


        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = '/service/client.svc/Forget_Password'; // 1
        var preconfirmtranslate = "sendforgetpassword"; // 2
        var postData = { UserForget: data } // 3
        var method = "POST"; // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login";
        });
    };
}]);
